import { post } from "../../helpers/api";

const getDefaultDashboardItems = () => ({
    expense: { total_amount_dollar: 0, total_amount_dinar: 0 },
    income: { total_amount_dollar: 0, total_amount_dinar: 0 },
    purchase: { total_purchase_amount_dollar: 0, total_purchase_amount_dinar: 0 },
    saleAndProfit: {
        total_sale_price_dollar: 0,
        total_sale_price_dinar: 0,
        total_profit_dollar: 0,
        total_profit_dinar: 0,
    },
    total_profit: { total_profit_dollar: 0, total_profit_dinar: 0 },
    returned_invoice: { total_returned_amount_dollar: 0, total_returned_amount_dinar: 0 },
    waste_cost: { total_waste_cost_dollar: 0, total_waste_cost_dinar: 0 },
    debt_discount: {
        total_discount_loss_dollar: 0,
        total_discount_loss_dinar: 0,
        total_discount_gain_dollar: 0,
        total_discount_gain_dinar: 0,
    },
    sale_type: [],
    item_sale: [],
    income_category: [],
    expense_category: [],
    invoices: [],
    debt_limit_exceeded_customers: [],
    notes: [],
    waste_item: [],
    debt: [],
    sales_trend: {},
});

const state = {
    items: getDefaultDashboardItems(),
    total: {},
    isLoadingData: true,
    isBtnLoading: false,
    isBtnEditLoading: false,
    search: "",
    isShowResultDialog: false,
    resultMsg: "",
    isSuccess: false,
};

const mutations = {
    SET_ITEMS(state, items) {
        state.items = {
            ...getDefaultDashboardItems(),
            ...(items || {}),
            expense: {
                ...getDefaultDashboardItems().expense,
                ...(items?.expense || {}),
            },
            income: {
                ...getDefaultDashboardItems().income,
                ...(items?.income || {}),
            },
            purchase: {
                ...getDefaultDashboardItems().purchase,
                ...(items?.purchase || {}),
            },
            saleAndProfit: {
                ...getDefaultDashboardItems().saleAndProfit,
                ...(items?.saleAndProfit || {}),
            },
            total_profit: {
                ...getDefaultDashboardItems().total_profit,
                ...(items?.total_profit || {}),
            },
            returned_invoice: {
                ...getDefaultDashboardItems().returned_invoice,
                ...(items?.returned_invoice || {}),
            },
            waste_cost: {
                ...getDefaultDashboardItems().waste_cost,
                ...(items?.waste_cost || {}),
            },
            debt_discount: {
                ...getDefaultDashboardItems().debt_discount,
                ...(items?.debt_discount || {}),
            },
            sale_type: Array.isArray(items?.sale_type) ? items.sale_type : [],
            item_sale: Array.isArray(items?.item_sale) ? items.item_sale : [],
            income_category: Array.isArray(items?.income_category) ? items.income_category : [],
            expense_category: Array.isArray(items?.expense_category) ? items.expense_category : [],
            invoices: Array.isArray(items?.invoices) ? items.invoices : [],
            debt_limit_exceeded_customers: Array.isArray(items?.debt_limit_exceeded_customers)
                ? items.debt_limit_exceeded_customers
                : [],
            notes: Array.isArray(items?.notes) ? items.notes : [],
            waste_item: Array.isArray(items?.waste_item) ? items.waste_item : [],
            debt: Array.isArray(items?.debt) ? items.debt : [],
            sales_trend: items?.sales_trend || {},
        };
        console.log(state.items);
        state.isLoadingData = false;
    },
    SET_IS_LOADING_DATA(state, isLoadingData) {
        state.isLoadingData = isLoadingData;
    },
    SET_IS_BTN_LOADING(state, isBtnLoading) {
        state.isBtnLoading = isBtnLoading;
    },
};

const actions = {
    async getItems({ commit }, payload) {
        commit("SET_IS_LOADING_DATA", true);
        try {
            return post("dashboard/get-report", payload, {
                    id: 1,
                    action: "view",
                })
                .then((response) => {
                    commit("SET_ITEMS", response.data);
                    commit("SET_IS_BTN_LOADING", false);
                    console.log(response.data);
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                    if (error?.response?.status == 401) {
                        window.location.href = "/login";
                    }
                    if (error?.response?.status == 408) {
                        //redirect to home
                        window.location.href = "/home";
                    }
                    return error;
                })
                .finally(() => {
                    commit("SET_IS_LOADING_DATA", false);
                });
        } catch (error) {
            console.log(error);
            commit("SET_IS_LOADING_DATA", false);
        }
    }, ///customer/get-total-debts-both
    async getTotalDebtsBoth({ commit }) {
        try {
            return post(
                    "customer/get-total-debts-both", {}, {
                        id: 1,
                        action: "view",
                    }
                )
                .then((response) => {
                    //use commit to set the total debts
                    commit("SET_IS_BTN_LOADING", false);
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                    return error;
                });
        } catch (error) {
            console.log(error);
            return error;
        }
    },
};

const getters = {
    getResultDialog: (state) => state.isShowResultDialog,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};